import { useState, useRef } from "react";

// 전체화면 이미지 뷰어 — 핀치 줌 + 더블탭 리셋 + 배경 클릭 닫기
export default function ImageViewer({ src, onClose }) {
  const [scale, setScale]   = useState(1);
  const lastDistRef          = useRef(null);
  const lastTapRef           = useRef(0);

  const getDist = (touches) => {
    const dx = touches[0].clientX - touches[1].clientX;
    const dy = touches[0].clientY - touches[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  };

  const onTouchStart = (e) => {
    if (e.touches.length === 2) {
      lastDistRef.current = getDist(e.touches);
    }
  };

  const onTouchMove = (e) => {
    if (e.touches.length === 2 && lastDistRef.current) {
      e.preventDefault();
      const dist = getDist(e.touches);
      const ratio = dist / lastDistRef.current;
      setScale((prev) => Math.min(5, Math.max(1, prev * ratio)));
      lastDistRef.current = dist;
    }
  };

  const onTouchEnd = (e) => {
    if (e.touches.length < 2) {
      lastDistRef.current = null;
    }
    // 더블탭 감지 → scale 리셋
    const now = Date.now();
    if (now - lastTapRef.current < 300) {
      setScale(1);
    }
    lastTapRef.current = now;
  };

  const handleBackdrop = () => {
    if (scale === 1) onClose();
    else setScale(1);
  };

  return (
    <div
      style={s.backdrop}
      onClick={handleBackdrop}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      {/* 닫기 버튼 */}
      <button
        style={s.closeBtn}
        onClick={(e) => { e.stopPropagation(); onClose(); }}
      >
        ✕
      </button>

      {/* 이미지 */}
      <img
        src={src}
        alt="전체화면 이미지"
        style={{
          ...s.img,
          transform: `scale(${scale})`,
          transformOrigin: "center center",
        }}
        onClick={(e) => e.stopPropagation()}
        draggable={false}
      />

      {/* 확대 중 안내 */}
      {scale > 1 && (
        <div style={s.hint}>배경 탭하면 원래 크기로</div>
      )}
      {scale === 1 && (
        <div style={s.hint}>두 손가락으로 확대 · 배경 탭하면 닫힘</div>
      )}
    </div>
  );
}

const s = {
  backdrop: {
    position: "fixed", inset: 0, background: "rgba(0,0,0,0.92)",
    display: "flex", alignItems: "center", justifyContent: "center",
    zIndex: 500, userSelect: "none", touchAction: "none",
  },
  closeBtn: {
    position: "absolute", top: 20, right: 20,
    width: 40, height: 40, borderRadius: "50%",
    background: "rgba(255,255,255,0.15)", border: "none",
    color: "#fff", fontSize: 18, cursor: "pointer",
    display: "flex", alignItems: "center", justifyContent: "center",
    zIndex: 501,
  },
  img: {
    maxWidth: "95vw", maxHeight: "85vh",
    objectFit: "contain", borderRadius: 4,
    transition: "transform 0.05s linear",
    pointerEvents: "none",
  },
  hint: {
    position: "absolute", bottom: 32, left: "50%",
    transform: "translateX(-50%)",
    fontSize: 12, color: "rgba(255,255,255,0.5)",
    whiteSpace: "nowrap", pointerEvents: "none",
  },
};
